module.exports = __webpack_public_path__ + "img/12.69191593.jpeg";